import { Module } from 'vuex'
import getters from './getters'
import mutations from './mutations'
import actions from './actions'
import { IAppState } from './types'

export const state = {} as IAppState

const App: Module<IAppState, any> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}

export default App
